import styled from 'styled-components';

export const GridCardList = styled.div`
  border: 1px solid #f4f4f5;
  box-shadow: 0px 4px 8px rgba(164, 172, 178, 0.1);
  border-radius: 8px;
  padding: 1rem 0rem;
  text-align: center;
  font-weight: 600;
`;
